import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { consumptionService } from "../../../../Services/AccountingServices/consumption.service";
import { AuthContext } from "../../../../Contexts/AuthContext";
import ProductsFilterModal from "../../../Common/ProductsFilterModal";
import ResultModal from "../../../Common/ResultModal";
import AddProductModal from "../../../Common/AddProductModal";
import CardWrap from "../../../Common/CardWrap";
import BasicInformation from "./BasicInformation/IndexBasicInformation";
import Article from "./Article/IndexArticle";

const ConsumptionCreate = () => {
  const { useAccounting } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const history = useHistory();

  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [loadModal, setLoadModal] = useState(false);
  const [values, setValues] = useState({
    storeId: 0,
    tenantId: 0,
    priceListId: 0,
  });
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [quantityMsg, setQuantityMsg] = useState("");

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    //vraćam ih na isActive true
    oldDeleted.forEach((el) => (el.isActive = true));

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );

    let newProducts = addedProducts.map((prod) => ({
      productGuid: prod.productGuid,
      productName: prod.productName,
      price: prod.price,
      quantity: Number(prod.quantity),
    }));

    newArr = newArr.concat(newProducts);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, price) => {
    setProducts([
      ...products,
      { productGuid, productName, price, quantity: 0 },
    ]);
  };

  const onSubmit = (data) => {
    let formatedDate = new Date(
      new Date(data.date).getTime() + 8 * 60 * 60 * 1000,
    );
    if (
      products.some(
        (e) => e.quantity === null || e.quantity === 0 || e.quantity < 0,
      )
    ) {
      setQuantityMsg("QuantityNotNullAndNotNegative");
      return false;
    }
    if (products.some((e) => e.quantity >= 100000)) {
      setQuantityMsg("QuantityMaxThousand");
      return false;
    }
    consumptionService
      .documentCreate(formatedDate, data.storeId.id, data.note, products)
      .then((res) => {
        console.log("aasdasdd", res);
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateSuccess-Title",
            text: "InitialState-ResultModal-CreateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };
  const handleCancel = () => {
    history.goBack();
  };

  const handleClose = () => {
    setModal({ show: false });
    history.push("/consumption");
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");
  }, []);

  return (
    <>
      <CardWrap subtitle={translator("InitialState-DocumentCreate")}>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <BasicInformation
            control={control}
            errors={errors}
            register={register}
            setValue={setValue}
            setValues={setValues}
            setProducts={setProducts}
            setLoadModal={setLoadModal}
            setModalValidationMsg={setModalValidationMsg}
          />
          <Article
            quantityMsg={quantityMsg}
            setQuantityMsg={setQuantityMsg}
            modalValidationMsg={modalValidationMsg}
            setModalValidationMsg={setModalValidationMsg}
            products={products}
            values={values}
            setProducts={setProducts}
            setShowProductModal={setShowProductModal}
            setShowFilterModal={setShowFilterModal}
          />

          <div
            className="container-fluid mt-4"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>
        </form>
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      {loadModal && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={values.storeId}
          prodList={products}
          documentOption={1}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {loadModal && (
        <AddProductModal
          show={showProductModal}
          tenantId={values.tenantId}
          priceListId={values.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default ConsumptionCreate;
